import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import { Title, Loader, Image } from '@landing/ui';
import { useIsSsr } from 'utils/hooks';
import { title, image, captchaText } from './constants';

import * as styles from './ContactForm.module.scss';

const Form = lazy(() => import('components/forms/Form'));

export default function ContactForm({ closeModal, inModal, initialEvent, getAdditionalFormData }) {
  const isSsr = useIsSsr();

  return (
    <div className={styles.wrapper}>
      <Image src={image} className={styles.picture} />
      <div className={styles.content}>
        <Title className={cn(styles.title, inModal && styles.modalTitle)} color="white">
          {title}
        </Title>
        {!isSsr && (
          <Suspense fallback={<Loader theme="fullHeight" />}>
            <Form
              captchaInfo={captchaText}
              closeModal={closeModal}
              inModal={inModal}
              initialEvent={initialEvent}
              getAdditionalFormData={getAdditionalFormData}
            />
          </Suspense>
        )}
      </div>
    </div>
  );
}
